export interface SalesforceResponse<T> {
  success: boolean;
  error?: string | null;
  records?: T[];
  fields?: IncidentQueryField[];
  values?: string[];
}

export interface IncidentQueryField {
  Label: string;
  DeveloperName: string;
  Field_API_Name__c: string;
  Field_Type__c: string;
  Available__c: boolean;
  Treat_as_Picklist__c?: boolean;
  Values__c?: string;
  attributes?: {
    type: string;
    url: string;
  };
  Id?: string;
}

export interface IncidentRecord {
  Id: string;
  [key: string]: any;
  attributes?: {
    type: string;
    url: string;
  };
}

export interface FilterCriteria {
  fieldName: string;
  operator: string;
  value: any;
}

export interface OrderByCriteria {
  fieldName: string;
  direction: "ASC" | "DESC";
}

export interface GroupByCriteria {
  fieldName: string;
  level: 1 | 2;
}

export interface GroupedData {
  groupValue: string;
  count: number;
  subgroups?: {
    groupValue: string;
    count: number;
    records: IncidentRecord[];
  }[];
  records?: IncidentRecord[];
}

export interface GroupByCriteria {
  fieldName: string;
  level: 1 | 2;
  dateGranularity?: "day" | "week" | "month" | "quarter" | "year";
}

export type FieldType =
  | "Checkbox"
  | "Currency"
  | "Date"
  | "DateTime"
  | "Number"
  | "Percent"
  | "Picklist"
  | "MultiselectPicklist"
  | "Text"
  | "TextArea";

export type OperatorType = {
  [K in FieldType]: string[];
};

export const FIELD_OPERATORS: OperatorType = {
  Checkbox: ["=", "!="],
  Currency: ["=", "!=", ">", "<", ">=", "<="],
  Date: ["=", "!=", ">", "<", ">=", "<="],
  DateTime: ["=", "!=", ">", "<", ">=", "<="],
  Number: ["=", "!=", ">", "<", ">=", "<="],
  Percent: ["=", "!=", ">", "<", ">=", "<="],
  Picklist: ["=", "!=", "IN", "NOT IN"],
  MultiselectPicklist: ["INCLUDES", "EXCLUDES"],
  Text: ["=", "!=", "LIKE", "NOT LIKE", "STARTS WITH", "ENDS WITH", "CONTAINS"],
  TextArea: ["LIKE", "NOT LIKE", "CONTAINS"],
};

export const GROUPABLE_FIELD_TYPES: FieldType[] = [
  "Picklist",
  "Text",
  "Date",
  "DateTime",
];
